import { SettingsPage } from '@apps-common/apps/portal/pages/settings/Index'

export const Settings = () => <SettingsPage />
